// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_payment_ui_styles" + "." + "f72af73b" + ".chunk.css";
};